import React, { DetailedHTMLProps, FC, HTMLAttributes } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { WithDataName } from 'common/types'
import { TextWaveUnderline } from 'components/designSystem/TextWaveUnderline/TextWaveUnderline'

export const More: FC<
  {
    onClick: DetailedHTMLProps<
      HTMLAttributes<HTMLSpanElement>,
      HTMLSpanElement
    >['onClick']
  } & WithDataName
> = ({ onClick, ...rest }) => {
  return (
    <Parent
      fontSize={16}
      variant="short-orange"
      onClick={onClick}
      title={
        <span>
          <FormattedMessage id="app.more" defaultMessage="Ещё" />
        </span>
      }
      data-name={rest['data-name']}
    />
  )
}

const Parent = styled(TextWaveUnderline)`
  text-transform: lowercase;
  color: var(--mamba-default);
  max-width: min-content;
  cursor: pointer;
`
